// extracted by mini-css-extract-plugin
export default {"root":"hero-image_root__7I9x5","babe":"hero-image_babe__n1aLF"};